// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sticky-notes[data-v-5d7131cc]{position:absolute;top:55px;left:0;height:calc(100vh - 75px);right:0\n}", ""]);
// Exports
module.exports = exports;
